import { create } from 'zustand'
import { doubleApi } from '../services/doubleApi'

const useDoubleStore = create((set) => ({
  // State
  activeRound: null,
  isLoading: false,
  isBetting: false,
  error: null,
  inventory: [],
  balance: 0,

  // Actions
  clearError: () => set({ error: null }),

  // Загрузка активного раунда для поллинга
  loadActiveRound: async (signal) => {
    try {
      set({ isLoading: true, error: null })
      const round = await doubleApi.getActiveRound(signal)

      if (round?.error) {
        const error = new Error(round.error)
        error.message = round.error
        throw error
      }

      set({
        activeRound: round,
        isLoading: false
      })

      return round
    } catch (error) {
      set({
        error: error.message || 'Ошибка загрузки раунда',
        isLoading: false
      })
      throw error
    }
  },

  // Загрузка данных для формы ставки
  loadBetForm: async (signal) => {
    try {
      set({ isLoading: true, error: null })
      const data = await doubleApi.getBetForm(signal)

      if (data?.error) {
        const error = new Error(data.error)
        error.message = data.error
        throw error
      }

      set({
        inventory: data.inventory || [],
        balance: Number(data.balance || 0),
        isLoading: false
      })

      return data
    } catch (error) {
      set({
        error: error.message || 'Инвентарь недоступен',
        isLoading: false
      })
      throw error
    }
  },

  // Отправка ставки
  placeBet: async ({ roundId, color, crystal, items }) => {
    try {
      set({ isBetting: true, error: null })

      const response = await doubleApi.placeBet({
        roundId,
        color,
        crystal,
        items
      })

      set({ isBetting: false })
      return response
    } catch (error) {
      set({
        error: error.message || 'Ошибка отправки ставки',
        isBetting: false
      })
      throw error
    }
  },

  // Загрузка обеих историй
  loadHistory: async () => {
    try {
      set({ isLoading: true, error: null })
      const [all, mine] = await Promise.all([
        doubleApi.getHistoryAll(),
        doubleApi.getHistoryMine()
      ])

      set({ isLoading: false })
      return {
        all: Array.isArray(all) ? all : [],
        mine: Array.isArray(mine) ? mine : []
      }
    } catch (error) {
      set({
        error: error.message || 'Ошибка загрузки истории',
        isLoading: false
      })
      throw error
    }
  },

  // Загрузка конкретного раунда
  loadRoundById: async (roundId) => {
    try {
      set({ isLoading: true, error: null })
      const round = await doubleApi.getRoundById(roundId)
      set({ isLoading: false })
      return round
    } catch (error) {
      set({
        error: error.message || 'Ошибка загрузки раунда',
        isLoading: false
      })
      throw error
    }
  }
}))

export default useDoubleStore
